import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      onClick={scrollToTop}
      size="icon"
      className="fixed bottom-28 lg:bottom-6 right-6 lg:left-6 lg:right-auto z-30 bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg rounded-full w-12 h-12 transition-all duration-300 hover:scale-110 border-2 border-white/20 backdrop-blur-sm"
      aria-label="חזור למעלה"
    >
      <ChevronUp className="h-6 w-6" />
    </Button>
  );
};

export default BackToTop;